import { render } from "./BaseTableArticles.vue?vue&type=template&id=76146780&scoped=true"
import script from "./BaseTableArticles.vue?vue&type=script&lang=js"
export * from "./BaseTableArticles.vue?vue&type=script&lang=js"

import "./BaseTableArticles.vue?vue&type=style&index=0&id=76146780&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76146780"]])

export default __exports__